import React, { Fragment, useEffect } from "react";
import { navigate } from "gatsby";
import { observer, inject } from "mobx-react";
import { Button, Card, CardContent, TextField, Typography } from "@material-ui/core";

const ShortCodeSearch = inject("store")(
    observer(({
            }) => {

            let shortCode = "";
            const handleClick = () => {
                if (shortCode) {
                    navigate(`/pay?shortCode=${shortCode}`);
                }
            }

            const handleChange = (e) => {
                shortCode = e.target.value.toUpperCase();
            }

            return (
                <Fragment>
                    <Card>
                        <CardContent>
                            <Typography>Make a quick online payment</Typography>
                            <TextField 
                                variant="outlined" 
                                placeholder="Enter your code" 
                                InputLabelProps={{
                                    shrink: true
                                  }}       
                                fullWidth={true}
                                onChange={e => handleChange(e)}
                            />
                            <Button 
                                variant="contained" 
                                color="primary" 
                                fullWidth={true}
                                onClick={handleClick}
                            >Pay now</Button>
                        </CardContent>
                    </Card>
                </Fragment>
            );
        }
    )
);

export default ShortCodeSearch;